import { atom } from 'recoil'
import MaintenanceType from '../types/MaintenanceType'

export const maintenanceState = atom<MaintenanceType>({
  key: 'maintenance',
  default: {
    start_time: '00:00',
    end_time: '00:00',
    day: '0000-00-00',
    flag: 0,
    display: 0,
  },
})
